import type { AxiosPromise } from 'axios';
import type { Payload } from '@/api/interfaces/payload';
import type { UserAccount } from '@/api/interfaces/user/user-account';
import webApiClient from '@/helpers/client/webapi-client';

export function getSlimAccounts(
  abortController: AbortController = new AbortController(),
): AxiosPromise<Payload<Array<UserAccount>>> {
  return webApiClient.get('/accounts', {
    signal: abortController.signal,
  });
}
